import { render } from "./OriginationChart.vue?vue&type=template&id=347cd640&scoped=true"
import script from "./OriginationChart.vue?vue&type=script&lang=js"
export * from "./OriginationChart.vue?vue&type=script&lang=js"

import "./OriginationChart.vue?vue&type=style&index=0&id=347cd640&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347cd640"]])

export default __exports__